
import React from 'react';
// material
import { Grid } from '@material-ui/core';
import SyncIcon from '@material-ui/icons/Sync';
// entities
import { Campaign } from '../../../../entities/site';
// components
import PieChart from './PieChart';
import ActionButton from '../../../../components/buttons/ActionButton';
import HasAccess from '../../../../components/auth/HasAccess';
// services
import { Roles } from '../../../../services/auth';

interface CampaignStatsRunProps {
  campaign: Campaign;
  onUpdate?(campaign: Campaign): void;
}

const CampaignStatsRun: React.FC<CampaignStatsRunProps> = (props) => {
  return (
    <Grid container>
      <Grid item xs={6}>
        <div style={styles.title}>Sent {props.campaign.totalSent} of {props.campaign.totalContacts}</div>
      </Grid>
      <Grid item xs={6}>
        <div style={styles.link}>
          <SyncIcon style={styles.linkicon} />
          <ActionButton
            textOnly
            name="Sync Campaigns Totals"
            onClick={() => props.onUpdate !== undefined ? props.onUpdate(props.campaign) : null}
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default CampaignStatsRun;

const styles: any = {
  title: {
    fontSize: 24,
    paddingTop: 20,
    textAlign: 'left',
    color: '#627995'
  },
  link: {
    color: "#00ABCA",
    fontSize: 16,
    paddingTop: 27,
    display: "flex",
    justifyContent: 'flex-end'
  },
  linkicon: {
    marginRight: 7,
  },
};


// WEBPACK FOOTER //
// ./src/pages/admin/campaign/components/CampaignStatsRun.tsx